import { getPage } from '../../content.js'

export default
{
    props:
    {
        pages: { type: Array, default: [] },
        title: { type: String, default: null },
        isCentered: { type: Boolean, default: false }
    },

    data()
    {
        return {
            links: []
        }
    },

    created()
    {
        this.links = this.pages.map(pageSlug => JSON.parse(JSON.stringify(getPage(pageSlug))))
    }
}
